import React, { useEffect, useMemo, useState } from 'react';
import _get from 'lodash/get';
import { Box } from '@tajawal/ct-web-design-system';
// @ts-ignore
import { LoyaltyClient } from '@tajawal/ct-web-account-sdk/lib/clients/loyalty.cleint';
import { useTranslation } from 'react-i18next';
import WalletIcon from '../assets/WalletIcon';
function WalletAmount(_a) {
    var _b, _c;
    var formatPrice = _a.formatPrice, language = _a.language, partnerContent = _a.partnerContent;
    var t = useTranslation().t;
    var _d = useState({}), wallet = _d[0], setWallet = _d[1];
    var _e = useState(false), isVerified = _e[0], setIsVerified = _e[1];
    var walletAmount = _get(wallet, 'availableBalance.points', 0);
    var displayedWalledAmount = useMemo(function () {
        return "".concat(formatPrice(walletAmount), " ").concat(t('MyAccount_WalletBrand_AlmosaferPoints'));
    }, [walletAmount, wallet]);
    var color = ((_b = partnerContent === null || partnerContent === void 0 ? void 0 : partnerContent.themeColors) === null || _b === void 0 ? void 0 : _b.primary) ? (_c = partnerContent === null || partnerContent === void 0 ? void 0 : partnerContent.themeColors) === null || _c === void 0 ? void 0 : _c.primary : '#ffffff';
    useEffect(function () {
        LoyaltyClient.checkBalance('_HEADER')
            .then(function (_a) {
            var data = _a.data, isSuccess = _a.isSuccess;
            setWallet(data);
            setIsVerified(isSuccess);
        })["catch"](function () { });
    }, []);
    if (!isVerified)
        return null;
    return (React.createElement(React.Fragment, null, walletAmount >= 0 && (React.createElement("span", { style: {
            display: 'flex',
            cursor: 'pointer'
        }, onClick: function () {
            return (window.location.href = "/".concat(language, "/myaccount/wallet"));
        } },
        React.createElement("div", { style: {
                border: "1px solid ".concat(color),
                borderRadius: '100px',
                margin: '15px 0',
                padding: '5px 10px',
                display: 'flex',
                alignItems: 'center'
            } },
            React.createElement(Box, { sx: {
                    marginRight: '5px',
                    marginLeft: '5px',
                    display: 'flex',
                    alignItems: 'center'
                } },
                React.createElement(WalletIcon, { color: color })),
            ' ',
            React.createElement("div", { style: {
                    marginRight: '5px',
                    marginLeft: '5px',
                    fontSize: '14px',
                    textAlign: 'center',
                    color: color
                } },
                React.createElement(React.Fragment, null, t('MyAccount.UserDashboard.WalletBalance')),
                React.createElement("strong", { style: { fontWeight: 600 } }, displayedWalledAmount)))))));
}
export default WalletAmount;
//# sourceMappingURL=WalletAmount.js.map